export default __webpack_public_path__ + "static/pragicts-automation-services-virtualization-671bc05c7688ad28ce58932d6dc57460.jpg";